var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "go-list-item",
      attrs: {
        "data-template": "article",
        "data-size": _vm.formModel.thumbnail ? _vm.formModel.size : "1x1",
      },
    },
    [
      _c("div", { staticClass: "go-card-main" }, [
        _vm.formModel.thumbnail
          ? _c("div", { staticClass: "go-card-header" }, [
              _c(
                "a",
                { staticClass: "go-card-img", on: { click: _vm.viewDetail } },
                [
                  _c("img", {
                    attrs: { loading: "lazy", src: _vm.formModel.thumbnail },
                    on: { error: _vm.onImageError },
                  }),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "go-card-body" },
          [
            _c("div", { staticClass: "go-block-header" }, [
              _c(
                "div",
                {
                  staticClass: "go-card-info",
                  staticStyle: {
                    "justify-content": "space-between",
                    width: "100%",
                  },
                },
                [
                  _vm.formModel.channel !== "Podcast Goover"
                    ? _c("div", { staticClass: "go-info-item go-channel" }, [
                        _c("span", { staticClass: "go-channel-thumb" }, [
                          _c("img", {
                            attrs: {
                              width: "16px",
                              height: "16px",
                              src: _vm.favicon,
                              alt: "twitter",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "go-channel-name" }, [
                          _vm._v(_vm._s(_vm.formModel.channel)),
                        ]),
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "go-card-label",
                          staticStyle: {
                            "background-color": "#ababab",
                            "border-radius": "13px",
                            padding: "5px",
                          },
                        },
                        [
                          _c(
                            "em",
                            {
                              staticClass: "go-text",
                              staticStyle: {
                                color: "#fff",
                                "font-size": "0.6875rem",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.convertRecapType(
                                      _vm.formModel.originParentDocDetail.media_type.find(
                                        function (type) {
                                          return ["DAILY", "WEEKLY"].includes(
                                            type
                                          )
                                        }
                                      )
                                    )
                                  ) +
                                  "\n              Goover"
                              ),
                            ]
                          ),
                        ]
                      ),
                  _vm._v(" "),
                  _vm.formModel.channel === "Podcast Goover"
                    ? _c("span", { staticClass: "go-card-icon" }, [
                        _c("i", {
                          staticClass: "go-icon-24 go-icon-headphones",
                        }),
                      ])
                    : _vm._e(),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-block-body" }, [
              _vm.formModel.channel === "Podcast Goover"
                ? _c(
                    "a",
                    {
                      staticClass: "go-card-title",
                      on: {
                        click: function ($event) {
                          return _vm.goToRecap(
                            _vm.formModel.other_info.recap_id
                          )
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.formModel.title))]
                  )
                : _c(
                    "a",
                    {
                      staticClass: "go-card-title",
                      on: { click: _vm.viewDetail },
                    },
                    [_vm._v(_vm._s(_vm.formModel.title))]
                  ),
              _vm._v(" "),
              _c("div", { staticClass: "go-card-desc" }, [
                _vm._v(_vm._s(_vm.formModel.content)),
              ]),
            ]),
            _vm._v(" "),
            _vm.formModel.channel === "Podcast Goover"
              ? _c("div", { staticClass: "go-block-body" }, [
                  _c("div", { staticClass: "go-block-wrap" }, [
                    _c("div", { staticClass: "go-card-info" }, [
                      _vm.formModel &&
                      _vm.formModel.other_info &&
                      _vm.formModel.other_info.host_img
                        ? _c("i", { staticClass: "go-user-thumb" }, [
                            _c("img", {
                              attrs: { src: _vm.formModel.other_info.host_img },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-text-wrap" }, [
                        _vm.formModel &&
                        _vm.formModel.other_info &&
                        _vm.formModel.other_info.speakers_info
                          ? _c(
                              "span",
                              {
                                staticClass: "go-user-name",
                                staticStyle: { "margin-left": "5px" },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formattedSpeakers(
                                        _vm.formModel.other_info.speakers_info
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-btn-area" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-icon",
                          class: {
                            active:
                              _vm.currentPlayingId === _vm.formModel._id &&
                              _vm.isPlaying,
                          },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.togglePlay(
                                _vm.formModel.url,
                                _vm.formModel._id
                              )
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "go-icon-24",
                            class:
                              _vm.currentPlayingId === _vm.formModel._id &&
                              _vm.isPlaying
                                ? "go-icon-player-pause-filled"
                                : "go-icon-player-play-filled",
                          }),
                        ]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("resource-footer", {
              attrs: {
                "form-model": _vm.formModel,
                "is-hide-options": _vm.isHideOptions,
                "is-hide-add-reference": _vm.isHideAddReference,
                "is-hide-goover": _vm.isHideGoover,
                "is-hide-hidden": _vm.isHideHidden,
                "is-hide-shared": _vm.isHideShared,
              },
              on: {
                "add-to-reference": _vm.addToReference,
                hide: function ($event) {
                  $event.stopPropagation()
                  return _vm.hide.apply(null, arguments)
                },
                share: _vm.share,
                "select-user-social": _vm.selectUserSocial,
                "toggle-resource": _vm.toggleResource,
                goover: _vm.goover,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.formModel.isNew
          ? _c("div", { staticClass: "go-card-new" })
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }